export default {"src":"https://search.testwiggot.com/_next/static/media/blue-blur.522ddc0e.svg","height":414,"width":293,"blurWidth":0,"blurHeight":0};